import React, { useState, useEffect } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

const GlobalLoader = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleToggle = (e) => {
      setOpen(!!e.detail?.loading);
    };

    window.addEventListener('loader:toggle', handleToggle);
    return () => window.removeEventListener('loader:toggle', handleToggle);
  }, []);

  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default GlobalLoader;
